
import IconosRedes from '../iconos/IconosRedes';
import IconosGenerales from '../iconos/IconosGenerales';
import TextoLi from './../basicos/TextoLi';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import React from 'react';

//Estilos definido para las redes de contacto
const RedesContacto = () => {
    return (
        <>
            <EstiloRedesCont>
                <li>
                    <IconosGenerales id="telefono" contacto="true" />
                    <Link to="tel:+34943211151%20"><TextoLi><span>672 61 02 67 / 651 07 45 00</span></TextoLi></Link>
                </li>
                <li><IconosRedes id="whatsapp" contacto="true" />
                    <Link to=" https://wa.me/34943211151%20"><TextoLi><span>672 61 02 67 / 651 07 45 00</span> </TextoLi>
                    </Link>
                </li>
                <li>
                    <IconosGenerales id="correo" contacto="true" />
                    <Link to="mailto:info@tuscursossepe.com">
                        <TextoLi>info@tuscursossepe.com</TextoLi>
                    </Link>
                </li>
                <li><IconosRedes id="facebook" contacto="true" />
                    <Link to="https://www.facebook.com/people/
                            Tus-Cursos-SEPE/100076320754305/">
                        <TextoLi>Tuscursossepe</TextoLi></Link>
                </li>
                <li><IconosRedes id="instagram" contacto="true" />
                    <Link to="https://www.instagram.com/tuscursossepe/">
                        <TextoLi>@tuscursossepe</TextoLi>
                    </Link>

                </li>
            </EstiloRedesCont>

        </>
    );
}


const EstiloRedesCont  = styled.ul`
    margin-top: 2%;
    list-style: none;

    li{
        padding-bottom: 10px; 
        padding-top: 5px;
        margin-bottom: 10%;
        display: flex;
        align-items: center;
        border-bottom-style: dashed;
        border-bottom-width: 1px;
        border-color: #ddd;
    }
    
`;


export default RedesContacto;